import { createAction } from "@reduxjs/toolkit";
import { Pageable } from "../../services/pageable";
import { FetchableError, FetchableSuccess } from "../common/fetchable/helpers";
import { CryptoDTO } from "./models/dto";

export namespace CryptoActions {
  export enum ActionTypes {
    getAllFraudReport = "Crypto: Get All Individual FraudReport",
    setAllFraudReport = "Crypto: Set All Individual FraudReport",
    resetAllFraudReport = "Crypto: Reset All Individual FraudReport",
    getSingleFraudReport = "Crypto: Get Single Individual FraudReport",
    setSingleFraudReport = "Crypto: Set Single Individual FraudReport",
    setAllFraudReportPagination = "Crypto: Set All Individual FraudReport Pagination",

    getFraudReportSummary = "Crypto: Get Fraud Report Summary",
    setFraudReportSummary = "Crypto: Set Fraud Report Summary",
    resetFraudReportSummary = "Crypto: Reset Fraud Report Summary",

    setNewFormReportSection = "Crypto: Set New Form Report Section",
  }

  export const resetAllFraudReport = createAction(
    ActionTypes.resetAllFraudReport
  );
  export const getAllFraudReport = createAction(ActionTypes.getAllFraudReport);

  export const setAllFraudReport = createAction<
    FetchableSuccess<CryptoDTO.Responses.GetAllFraudReport.T> | FetchableError,
    ActionTypes.setAllFraudReport
  >(ActionTypes.setAllFraudReport);

  export const setAllFraudReportPagination = createAction<
    Pageable.T<keyof CryptoDTO.Responses.GetSingleFraudReport.T>,
    ActionTypes.setAllFraudReportPagination
  >(ActionTypes.setAllFraudReportPagination);

  export const getSingleFraudReport = createAction<
    CryptoDTO.Responses.GetSingleFraudReport.T["id"],
    ActionTypes.getSingleFraudReport
  >(ActionTypes.getSingleFraudReport);

  export const setNewFormReportSection = createAction<
    Partial<CryptoDTO.Requests.CreateFraudReport.T>,
    ActionTypes.setNewFormReportSection
  >(ActionTypes.setNewFormReportSection);

  export const setSingleFraudReport = createAction<
    {
      id: string;
      result: CryptoDTO.Responses.GetSingleFraudReport.T;
    },
    ActionTypes.setSingleFraudReport
  >(ActionTypes.setSingleFraudReport);

  export const getFraudReportSummary = createAction(
    ActionTypes.getFraudReportSummary
  );
  export const resetFraudReportSummary = createAction(
    ActionTypes.resetFraudReportSummary
  );

  export const setFraudReportSummary = createAction<
    | FetchableSuccess<CryptoDTO.Responses.GetFraudReportSummary.T>
    | FetchableError,
    ActionTypes.setFraudReportSummary
  >(ActionTypes.setFraudReportSummary);

  export type GetAllFraudReport = ReturnType<typeof getAllFraudReport>;
  export type SetAllFraudReport = ReturnType<typeof setAllFraudReport>;
  export type GetSingleFraudReport = ReturnType<typeof getSingleFraudReport>;
  export type SetSingleFraudReport = ReturnType<typeof setSingleFraudReport>;
  export type ResetAllFraudReport = ReturnType<typeof resetAllFraudReport>;
  export type SetNewFormReportSection = ReturnType<
    typeof setNewFormReportSection
  >;
  export type SetAllFraudReportPagination = ReturnType<
    typeof setAllFraudReportPagination
  >;
  export type GetFraudReportSummary = ReturnType<
    typeof getFraudReportSummary
  >;
  export type SetFraudReportSummary = ReturnType<
    typeof setFraudReportSummary
  >;
  export type ResetFraudReportSummary = ReturnType<
    typeof resetFraudReportSummary
  >;

  export type Actions =
    | GetAllFraudReport
    | SetAllFraudReport
    | GetSingleFraudReport
    | SetSingleFraudReport
    | ResetAllFraudReport
    | SetNewFormReportSection
    | SetAllFraudReportPagination
    | GetFraudReportSummary
    | SetFraudReportSummary
    | ResetFraudReportSummary;
}
